import { render } from "./MatchesHome.vue?vue&type=template&id=292eba18&scoped=true"
import script from "./MatchesHome.vue?vue&type=script&lang=js"
export * from "./MatchesHome.vue?vue&type=script&lang=js"

import "./MatchesHome.vue?vue&type=style&index=0&id=292eba18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292eba18"]])

export default __exports__